module.exports = __webpack_public_path__ + "static/media/ZILLASLAB-SEMIBOLD_0.da232f8a.OTF";